const setSyncLoading = (state, payload) => {
  if (state.isSyncing > 2) {
    return
  }
  state.isSyncing = payload
}

export default {
  setSyncLoading,
}
